import * as Popover from "@radix-ui/react-popover";
import { styled } from "@vitality-ds/system";
import PopoverContentStyles from "./styles/PopoverContentStyles.styles";
import PopoverRootStyles from "./styles/PopoverRootStyles.styles";
import PopoverTriggerStyles from "./styles/PopoverTriggerStyles.styles";

// eslint-disable-next-line import/prefer-default-export
export var PopoverRoot = styled(Popover.Root, PopoverRootStyles);
export var PopoverTrigger = styled(Popover.Trigger, PopoverTriggerStyles);
export var PopoverContent = styled(Popover.Content, PopoverContentStyles);